import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { PatronesWltpComponent } from "./patrones-wltp.component";
import { SelectedDatosComponent } from "./selected-datos/selected-datos.component";
import { ListWltpComponent } from "./list-wltp/list-wltp.component";
import { LoginGuard } from "../core/guards/login.guard";
import { PwdExpiratedGuard } from "../core/guards/pwdExpirated";

const routesPatronesWltp: Routes = [
  {
    path: "",
    component: PatronesWltpComponent,
    canActivate: [LoginGuard, PwdExpiratedGuard],
    children: [
      {
        path: "lista",
        component: ListWltpComponent,
      },
      // {
      //   path: "creacion",
      //   component: SelectedDatosComponent,
      //   data: {
      //     operation: "creacion",
      //   },
      // },
      {
        path: "display/:id",
        component: SelectedDatosComponent,
        data: {
          operation: "display",
        },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routesPatronesWltp)],
  exports: [RouterModule],
})
export class PatronesWltpRoutingModule {}
